/**
 * Normalize nested vehicle/model shapes and return { code, name }.
 */
export function getVehicleCodeName(source, options = {}) {
  const { code: codeOpt, name: nameOpt } = options;

  if (source == null || source === "") {
    return {
      code: codeOpt != null ? String(codeOpt).trim() : "",
      name: nameOpt != null ? String(nameOpt).trim() : "",
    };
  }

  if (typeof source === "string") {
    return { code: "", name: source };
  }

  const nested =
    source.vehicleDetail?.model ||
    source.vehicleDetail ||
    source.VehicleMaster ||
    source.vehicle?.VehicleMaster ||
    source.vehicle?.vehicle ||
    source.vehicle ||
    source.soldVehicle?.vehicle ||
    source.model ||
    source;

  const modelCode =
    codeOpt != null && codeOpt !== ""
      ? codeOpt
      : nested.modelCode != null
      ? nested.modelCode
      : source.modelCode != null
      ? source.modelCode
      : "";

  const modelName =
    nameOpt != null && nameOpt !== ""
      ? nameOpt
      : nested.modelName != null
      ? nested.modelName
      : source.modelName != null
      ? source.modelName
      : nested.name != null
      ? nested.name
      : "";

  return {
    code: modelCode != null ? String(modelCode).trim() : "",
    name: modelName != null ? String(modelName).trim() : "",
  };
}

/**
 * Normalize nested vehicle/model shapes and return a full display name.
 * Default: "modelCode - modelName" (whichever fields exist).
 */
export function formatVehicleName(source, options = {}) {
  const { fallback = "" } = options;
  const { code, name } = getVehicleCodeName(source, options);
  return joinCodeName(code, name) || fallback;
}

function joinCodeName(modelCode, modelName) {
  const code = modelCode != null ? String(modelCode).trim() : "";
  const name = modelName != null ? String(modelName).trim() : "";
  if (code && name) return `${code} - ${name}`;
  return name || code || "";
}

/**
 * Name-only display (no modelCode prefix). Use where UI historically showed only modelName.
 */
export function formatVehicleNameOnly(source, fallback = "") {
  if (source == null || source === "") return fallback;
  if (typeof source === "string") return source;
  const nested =
    source.vehicleDetail?.model ||
    source.vehicleDetail ||
    source.VehicleMaster ||
    source.vehicle?.vehicle ||
    source.vehicle ||
    source.model ||
    source;
  const name =
    nested.modelName ||
    source.modelName ||
    nested.name ||
    "";
  return name ? String(name).trim() : fallback;
}
